<template>
  <el-dialog
    v-if="cancellation"
    id="coachCancellationDialog"
    :title="`Meeting cancellation for ${cancellation.leader_name}`"
    :visible.sync="showLocal"
    :width="dialogWidth"
    @open="open"
  >
    <div class="content">
      <div
        v-if="panel === 1"
        id="panel1"
      >
        <div class="label">
          <i18n path="customAlert.coach.cancellations.meetingCancellation">
            <template #leader>
              {{ cancellation.leader_name }}
            </template>
          </i18n>
          <br /><br />
          {{ $t('customAlert.coach.cancellations.leadersReason') }}:
          <br />
          <b>{{ cancellation.reason }}</b>
          <br /><br />
          {{ $t('customAlert.coach.cancellations.doYouWant') }}
        </div>
        <div class="response">
          <el-radio-group v-model="acceptCancellation">
            <el-radio :label="true">
              {{ $t('customAlert.coach.cancellations.allow') }}
            </el-radio>
            <el-radio :label="false">
              {{ $t('customAlert.coach.cancellations.notAllow') }}
            </el-radio>
          </el-radio-group>
        </div>
      </div>

      <div
        v-if="panel === 2"
        id="panel2"
      >
        <div
          v-if="acceptCancellation === true"
          class="label"
        >
          {{ $t('customAlert.coach.cancellations.confirmAllow') }}
        </div>
        <div
          v-else
          class="label"
        >
          {{ $t('customAlert.coach.cancellations.confirmNotAllow') }}
        </div>
      </div>
    </div>

    <div
      slot="footer"
      class="dialog-footer"
    >
      <span v-if="panel === 1">
        <el-button
          type="secondary"
          round
          @click="showLocal = false"
        >
          {{ $t('common.discard') }}
        </el-button>
        <el-button
          type="primary"
          :disabled="acceptCancellation === null"
          round
          @click="panel = 2"
        >
          <span>
            {{ $t('common.submit') }}
          </span>
        </el-button>
      </span>

      <span v-if="panel === 2">
        <el-button
          type="secondary"
          round
          @click="panel = 1"
        >
          {{ $t('common.goBack') }}
        </el-button>
        <el-button
          type="primary"
          round
          @click="submitCancellation"
        >
          <span>
            {{ $t('common.confirm') }}
          </span>
        </el-button>
      </span>
    </div>
  </el-dialog>
</template>

<script>
import DialogSetting from '@/mixins/dialog';
import api from '@/api';

export default {
  mixins: [DialogSetting],

  props: {
    cancellation: {
      type: Object,
      default: null,
    },
  },

  data() {
    return {
      panel: 1,
      acceptCancellation: null,
    };
  },

  methods: {
    open() {
      this.panel = 1;
      this.acceptCancellation = null;
    },

    async submitCancellation() {
      try {
        const response = await api.coachValidateCancellation(
          this.cancellation.uuid,
          { is_accepted: this.acceptCancellation },
        );

        this.sendEventBus(response.data.uuid);
        this.$message.success(this.$t('customAlert.coach.cancellations.confirmed'));
        this.showLocal = false;
      } catch (err) {
        if (err.msg) {
          this.$message.error(err.msg);
        }
      }
    },

    sendEventBus(uuid) {
      this.$EventBus.$emit('alert_changed', { type: 'Cancellation', uuid });
    },
  },
};
</script>

<style lang="scss" scoped>
#coachCancellationDialog {
  .content {
    .response {
      margin-top: 25px;

      .el-radio-group {
        display: flex;
        justify-content: space-around;
        flex-wrap: wrap;
        margin: 0 auto;

        .el-radio {
          display: flex;
          width: 100%;
          margin: 5px 0;
        }
      }
    }
  }

  .dialog-footer {
    text-align: center;
  }
}
</style>

<style lang="scss">
  #coachCancellationDialog {
    .content {
      .response {
        .el-radio-group {
          .el-radio__label {
            word-break: break-word;
            white-space: normal;
          }
        }
      }
    }
  }
</style>
